/**
 * Single source of truth for the Ko-fi support link.
 *
 * The button sits with the r/FromAfar community-partner widgets on the right
 * hand rail — see SupportKoFiButton and ResponsiveSubredditWidget.
 */

export const KOFI = {
  handle: 'theviewshed',
  url: 'https://ko-fi.com/theviewshed',
  label: 'Support us on Ko-fi',
} as const;
